import React, {useEffect, useState} from "react";
import "./GamePage.sass";
import Window from "../../../../_containers/window/Window";
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import Game from "./Game";
import TextFieldEdit from "../../../../_components/common/fields/TextFieldEdit";
import ButtonComponent from "../../../../_components/common/buttons/ButtonComponent";
import {useDispatch, useSelector} from "react-redux";
import {FAILED, IDLE, LOADING, SUCCESS} from "../../../../common/statuses";
import Spinner from "../../anonymous/Spinner";
import {getTask, sendAnswer} from "../../../../_actions/game/gameService";
import {Navigate, useNavigate} from "react-router";
import {getNameByValue, solveTypes, taskTypes, themes} from "../../../../common/themes";
import {PHASE_ANSWER, PHASE_PREPARE, PHASE_RESULT} from "./phases";
import {setClearAnswer, setClearTask} from "../../../../_actions/game/gameReduce";
import _ from "lodash";
import {useSnackbar} from "notistack";
import Fact from "../../../../_components/student/fact/Fact";
import {ORDINARY} from "../../../../common/taskTypes";
import {HOME} from "../../../../common/links";

export default function GamePage() {
    const [phase, setPhase] = useState(PHASE_PREPARE);
    const [isShowResult, setIsShowResult] = useState(false);
    const [myAnswer, setMyAnswer] = useState("");
    const [isShowFact, setIsShowFact] = useState(false);

    const {data: task, status: taskStatus} = useSelector(state => state.game.task);
    const {data: setting} = useSelector(state => state.game.setting);
    const {data: answer, status: answerStatus} = useSelector(state => state.game.answer);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        if (taskStatus === IDLE) {
            if (setting) {
                const body = {
                    hwStepId: setting.id,
                    ...setting
                }

                dispatch(getTask(body))
            } else {
                if (window.history.state && window.history.state.idx > 0) {
                    console.log("Невозможно открыть игру, т.к. setting не заполнен");
                    navigate(-1);
                } else {
                    navigate('/home', {replace: true}); // the current entry in the history stack will be replaced with the new one with { replace: true }
                }
            }
        }
        if (taskStatus === FAILED) {
            enqueueSnackbar("Неизвесная ошибка, попробуйте позже", {variant: "error"})
        }
    }, [taskStatus, dispatch]);
    useEffect(() => {
        if (answerStatus === FAILED) {
            enqueueSnackbar("Ошибка: Отправьте ответ позже", {variant: "error"})
        }
        if (answerStatus === SUCCESS) {
            setPhase(PHASE_RESULT);
            if (answer.message) {
                setIsShowFact(true);
            }
        }
    }, [answerStatus])
    useEffect(() => {
        document.title = 'КьюАй - Игра Ментальная арифметика'
        return () => {
            dispatch(setClearTask())
            dispatch(setClearAnswer())
        }
    }, [])

    if (taskStatus === FAILED) {
        return <Navigate to={HOME}/>
    }

    if (taskStatus === IDLE || taskStatus === LOADING
        || answerStatus === LOADING) {
        return <Spinner/>
    }

    const handleSendAnswer = () => {
        if (_.isEmpty(myAnswer)) {
            enqueueSnackbar("Заполните поле Ответ", {variant: "error"})
        } else {
            const body = {
                id: task.id,
                values: task.values,
                myAnswer: myAnswer.replace(/[^0-9]/g, "")
            }
            dispatch(sendAnswer(body));
        }
    }

    const renderEye = () => {
        return <div className="GamePage-eye-container">
            <VisibilityOffOutlinedIcon/>
        </div>
    }

    const renderExercise = () => {
        return <div className="GamePage-answer-grid">
            <div className="GamePage-answer-grid-answer">Ответ: {answer.rightAnswer}</div>
            {task.values.map((value, i) => <div key={`GamePage-answer-item-${i}`}
                                                className="GamePage-answer-grid-item">
                    <div className="GamePage-answer-grid-item-number">{i + 1}</div>
                    <div className="GamePage-answer-grid-item-value">{value}</div>
                </div>
            )}
        </div>
    }

    return (
        <Window>
            <div className="GamePage-setting-area">
                <div className="GamePage-setting">
                    <div className="GamePage-setting-icon"><CalculateOutlinedIcon/></div>
                    <div className="GamePage-setting-label"><b>Тема:</b> {getNameByValue(themes, task.setting.theme)}
                    </div>
                </div>
                <div className="GamePage-setting">
                    <div className="GamePage-setting-icon"><SpeedOutlinedIcon/></div>
                    <div className="GamePage-setting-label"><b>Скорость:</b> {task.setting.speed} сек</div>
                </div>
                <div className="GamePage-setting">
                    <div className="GamePage-setting-icon"><ExtensionOutlinedIcon/></div>
                    <div className="GamePage-setting-label"><b>Сложность:</b> {task.setting.complexity}</div>
                </div>
                <div className="GamePage-setting">
                    <div className="GamePage-setting-icon"><ContactSupportOutlinedIcon/></div>
                    <div className="GamePage-setting-label">
                        <b>Способ:</b> {getNameByValue(solveTypes, task.setting.solveType)}</div>
                </div>
                <div className="GamePage-setting">
                    <div className="GamePage-setting-icon"><AutoModeIcon/></div>
                    <div className="GamePage-setting-label">
                        <b>Тип:</b> {getNameByValue(taskTypes, task.setting.taskType)}</div>
                </div>
            </div>
            <div className="GamePage-main">
                <Game setPhase={setPhase} phase={phase} myAnswer={myAnswer}
                      taskType={task.setting.taskType || ORDINARY}/>
                <div className="GamePage-right-panel">
                    <TextFieldEdit disabled={phase !== PHASE_ANSWER}
                                   label="Ответ"
                                   value={myAnswer}
                                   onChange={(e) => {
                                       const value = e.target.value.replace(/[^0-9]/g, "")
                                       if (parseInt(value) > 1000000) {
                                           setMyAnswer("999999")
                                       } else {
                                           setMyAnswer(value)
                                       }
                                   }}
                                   type="number"/>
                    <ButtonComponent disabled={phase !== PHASE_ANSWER}
                                     onClick={handleSendAnswer}>
                        Ввести ответ
                    </ButtonComponent>
                    <div className="GamePage-answer-panel">
                        {
                            isShowResult && answer ? renderExercise() : renderEye()
                        }
                    </div>
                    <ButtonComponent disabled={phase !== PHASE_RESULT}
                                     onClick={() => setIsShowResult(true)}>
                        Показать ответ
                    </ButtonComponent>
                    <ButtonComponent disabled={!(answer && answer.hasNext)}
                                     onClick={() => {
                                         dispatch(setClearAnswer());
                                         dispatch(setClearTask());
                                         setPhase(PHASE_PREPARE);
                                         setMyAnswer("");
                                         setIsShowResult(false);
                                     }}>Следующий пример <ArrowForwardIcon/></ButtonComponent>
                    <ButtonComponent onClick={() => navigate(-1)}><ArrowBackIcon/> Назад</ButtonComponent>
                </div>
            </div>
            {isShowFact && <Fact title="Знаете ли вы?"
                                 onClose={() => setIsShowFact(false)}>{answer.message}</Fact>}
        </Window>
    )
}